export const AppConfig = {
  site_name: 'My Muscle Chef',
  title: 'My Muscle Chef',
  description: 'We Sell Meals',
  locale: 'en',
};
